import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerMemberManagementDashboardType } from "../../looker-member-management-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-recon-capitation",
  templateUrl: "./recon-capitation.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReconCapitationComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerMemberManagementDashboardType.Reconciliation_Capitation_Report;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID, HideFilters.CUSTOMER_NAME2];
}
